import { render, staticRenderFns } from "./all-time-best-sellers.vue?vue&type=template&id=7991c00d"
import script from "./all-time-best-sellers.vue?vue&type=script&lang=js"
export * from "./all-time-best-sellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports